module.exports = __webpack_public_path__ + "static/media/traffic-road.9ccfeaa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/traffic-road.svg
// module id = 870
// module chunks = 0